/* eslint-disable dot-notation */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/button-has-type */
/* eslint-disable prettier/prettier */
import { Grid, Typography } from '@material-ui/core';
import { gameVariablesTemplateActions } from '@orientaction/api-actions';
import type { PageRestitution } from '@orientaction/types';
import { gameBookValues, gameVariables, gameVariableValues } from '@orientaction/reducers';
import { labelBlockToShow, getIllustrationUrl } from '@orientaction/utils';
import { useEffect, useMemo, useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import EditorCitation from '../../EditorCitation';
import EditorImg from '../../EditorImg';
import style from '../style';
import { styleSelect } from '../styleSelect';
import EditorQuill from '@orientaction/components/EditorQuill/index';
import cloneDeep from 'lodash/cloneDeep';

const ModelVariable1 = (props: any) => {
  const {
    onChoiceClick,
    indexVariable,
    indexPageRestitutionNumber,
    isLastPage
  } = props;
  const classes = style();
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState('');
  const [position, setPosition] = useState<any>({});
  const [open, setOpen] = useState<boolean>(false);

  const dispatch = useDispatch();
  const valuesBooksTemplate = useSelector(gameBookValues);
  const allVariables = useSelector(gameVariables);
  const valuesVariablesData = useSelector(gameVariableValues);

  const valuesVariables = useMemo(() => {
    return valuesVariablesData.page_restitution[indexPageRestitutionNumber];
  }, [valuesVariablesData, indexPageRestitutionNumber]);

  const [typeBloc, setTypeBloc] = useState<Array<string>>(['normal', 'normal']);
  const [restitution, setRestitution] = useState<any>({});
  const optionsValue = [
    {
      value: 'normal',
      label: 'Normal',
    },
    {
      value: 'citation',
      label: 'Citation',
    },
    {
      value: 'encyclopedia',
      label: 'Encyclopédie',
    },
  ];

  const handleFieldChange = (field: keyof PageRestitution, value: any) => {
    const newValues: Record<string, any> = cloneDeep(valuesVariables);
    newValues[field] = value;
    valuesVariablesData.page_restitution[indexPageRestitutionNumber] = newValues as PageRestitution;
    dispatch(gameVariablesTemplateActions.setPageRestitution(valuesVariablesData.page_restitution))
  };

  const handleImageVariable = (data: any) => {
    if (data !== null) {
      const { id, url: urlImg } = data
      const illustration = {
        id,
        url: urlImg
      }
      handleFieldChange('illustration', illustration);
    } else {
      handleFieldChange('illustration', null);
    }
  }
  const handleVideoVariable = (data: any) => {
    if (data !== null) {
      const { video, autoPlayVideo, muteVideo, videoFile, videoToDelete } = data;
      const newValues = cloneDeep(valuesVariables);
      newValues['video'] = video;
      newValues['videoEn'] = data.videoEn || '';
      newValues['autoPlayVideoEn'] = data.autoPlayVideoEn || 0;
      newValues['muteVideoEn'] = data.muteVideoEn || 0;
      newValues['autoPlayVideo'] = autoPlayVideo;
      newValues['muteVideo'] = muteVideo;
      newValues['videoFile'] = videoFile || null;
      newValues['videoToDelete'] = videoToDelete || null;
      valuesVariablesData.page_restitution[indexPageRestitutionNumber] = newValues;
      dispatch(gameVariablesTemplateActions.setPageRestitution(valuesVariablesData.page_restitution))
    } else {
      const newValues = cloneDeep(valuesVariables);
      newValues['video'] = null;
      newValues['videoEn'] = null;
      newValues['autoPlayVideoEn'] = null;
      newValues['muteVideoEn'] = null;
      newValues['autoPlayVideo'] = null;
      newValues['muteVideo'] = null;
      newValues['videoFile'] = null;
      newValues['videoToDelete'] = null;
      valuesVariablesData.page_restitution[indexPageRestitutionNumber] = newValues;
      dispatch(gameVariablesTemplateActions.setPageRestitution(valuesVariablesData.page_restitution))
    }
  }

  const handleOpen = (event: any) => {
    onChoiceClick(true);
    event.preventDefault();
  };

  const handleFileUrlChange = (urlC: string) => {
    setUrl(urlC);
  };
  const handleFileChange = (fileC: any) => {
    // handleFieldChange('files', fileC);
    // setFile(fileC);
  };

  const handleDeleteFile = () => {
    setFile(null);
    setUrl('');
  };
  const handleChangeSelect = (selected: any, numberBlock: number) => {
    setTypeBloc((prevTypes) => {
      const newTypes = [...prevTypes];
      newTypes[numberBlock] = selected;
      return newTypes;
    });
  };

  // useEffect(() => {
  //   if (allVariables) {
  //     console.log({valuesVariables, all: allVariables[indexVariable]})
  //     const varIndexed = {
  //       ...(allVariables[indexVariable]),
  //       contentForType1: allVariables[indexVariable]?.contentForType1 ? allVariables[indexVariable].contentForType1 : 'normal',
  //       contentForType2: allVariables[indexVariable]?.contentForType2 ? allVariables[indexVariable].contentForType2 : 'normal',
  //     };
  //     console.log({varIndexed, all: allVariables[indexVariable]})
  //     dispatch(gameVariablesTemplateActions.setAllValues(varIndexed));
  //   } 
  // }, [indexVariable, allVariables])


  return (
    <div
      className={classes.container}
      onClick={(e) => e.stopPropagation()}
      key={indexPageRestitutionNumber}
    >
      <Grid className={classes.blockPadding} container={true} style={{ height: '100%' }}>
        <Grid
          item={true}
          sm={12}
          className={classes.blockContentParent}
        >
          <div className={classes.blockContent}>
            <Typography variant="h5" className={classes.title}>
              Illustration
            </Typography>
            <div style={{ marginTop: 15, position: 'relative' }}>
              <EditorImg
                width={508}
                height={410}
                handleFile={handleFileChange}
                defaultUrl={
                  getIllustrationUrl(valuesVariables?.illustration)
                }
                bilingualVideo={valuesVariables}
                defaultUrlVideo={valuesVariables?.video || ''}
                isVariable={true}
                indexPageRestitutionNumber={indexPageRestitutionNumber}
                handleImageVariable={handleImageVariable}
                handleVideoVariable={handleVideoVariable}
                auto={valuesVariables?.autoPlayVideo || 0}
                muteVideo={valuesVariables?.muteVideo || 0}
              />
            </div>
          </div>
          <div className={classes.blockContent}>
            <div className={classes.blockType}>
              <Typography variant="h5" className={classes.title}>
                {labelBlockToShow[valuesVariables?.contentForType2]}
              </Typography>
              <div className={classes.blockTypeInside}>
                <Typography variant="h5" className={classes.titleType}>
                  Type de bloc :
                </Typography>
                <Select
                  className={classes.select}
                  options={optionsValue}
                  value={optionsValue.find(
                    (option) => option.value === valuesVariables?.contentForType2,
                  )}
                  onChange={(selected) => {
                    handleChangeSelect(selected?.value, 0);
                    handleFieldChange('contentForType2', selected?.value);
                  }}
                  styles={styleSelect}
                />
              </div>
            </div>
            <div className={classes.blockText}>
              {valuesVariables?.contentForType2 === 'normal' && (
                <EditorQuill
                  isSmall={true}
                  styleEditor={null}
                  defaultValue={valuesVariables?.p2 || ''}
                  onChange={(content) => {
                    handleFieldChange('p2', content);
                  }}
                />
              )}
              {valuesVariables?.contentForType2 === 'citation' && (
                <EditorCitation
                  key={valuesVariables?.id}
                  fieldUpdate="citationContent2"
                  fieldUpdateTwo="citationAuthor2"
                  defaultValue={valuesVariables?.citationContent2}
                  defaultAutor={valuesVariables?.citationAuthor2}
                  isVariable={true}
                  handleFieldChangeC={handleFieldChange}
                />
              )}
              {valuesVariables?.contentForType2 === 'encyclopedia' && (
                <EditorQuill
                  isSmall={true}
                  styleEditor={null}
                  defaultValue={valuesVariables?.informationEncyclopedia2 || ''}
                  onChange={(content) => {
                    handleFieldChange('informationEncyclopedia2', content);
                  }}
                />
              )}
            </div>
          </div>
        </Grid>
        <Grid item={true} sm={12} className={classes.blockContentParent}>
          <div
            className={classes.blockContent}
            style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            <div className={classes.blockType}>
              <Typography variant="h5" className={classes.title}>
                {labelBlockToShow[valuesVariables?.contentForType1]}
              </Typography>
              <div className={classes.blockTypeInside}>
                <Typography variant="h5" className={classes.titleType}>
                  Type de bloc :
                </Typography>
                <Select
                  className={classes.select}
                  options={optionsValue}
                  value={optionsValue.find(
                    (option) => option.value === valuesVariables?.contentForType1,
                  )}
                  onChange={(selected) => {
                    if (selected) {
                      handleChangeSelect(selected.value, 1);
                      handleFieldChange('contentForType1', selected.value);
                    }
                  }}
                  styles={styleSelect}
                />
              </div>
            </div>
            <div className={classes.blockText2}>
              {valuesVariables?.contentForType1 === 'normal' && (
                <EditorQuill
                  isSmall={false}
                  styleEditor={null}
                  defaultValue={valuesVariables?.p1 || ''}
                  onChange={(content) => {
                    handleFieldChange('p1', content);
                  }}
                />
              )}
              {valuesVariables?.contentForType1 === 'citation' && (
                <EditorCitation
                  fieldUpdate="citationContent1"
                  fieldUpdateTwo="citationAuthor1"
                  defaultValue={valuesVariables?.citationContent1}
                  defaultAutor={valuesVariables?.citationAuthor1}
                  isVariable={true}
                  handleFieldChangeC={handleFieldChange}
                />
              )}
              {valuesVariables?.contentForType1 === 'encyclopedia' && (
                <EditorQuill
                  isSmall={false}
                  styleEditor={null}
                  defaultValue={valuesVariables?.informationEncyclopedia1 || ''}
                  onChange={(content) => {
                    // dispatch(gameVariablesTemplateActions.updateField('informationEncyclopedia1', content));
                    handleFieldChange('informationEncyclopedia1', content);
                  }}
                />
              )}
            </div>
          </div>
          {!isLastPage && 
            <div
              className={classes.blockContent}
              style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
            >
              <Typography variant="h5" className={classes.title}>
                Choix
              </Typography>
              <div
                className="wrapperchoices"
                style={{ fontFamily: 'Poppins', fontSize: 12, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10, height: '100%', backgroundColor: 'rgb(241, 241, 241)', padding: '10px' }}
              >
                Pas de personnalisation disponible <br />
                (l'utilisateur a un bouton qui lui permet de retourner à sa liste de jeux)
              </div>
            </div>
          }
          {isLastPage && 
            <div
              className={classes.blockContent}
              style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
            >
              <Typography variant="h5" className={classes.title}>
                FIN DE PAGE
              </Typography>
              <div
                className="wrapperchoices"
                style={{ fontFamily: 'Poppins', fontSize: 14, textAlign: 'left', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10, height: '100%', padding: '5px', color: '#272727'}}
              >
                La dernière page sera automatiquement considéré comme étant la dernière page de cette restitution. <br />
                Si cette page n'est pas la dernière le bouton sera "Suivant". <br />
                Si cette page est la dernière, le bouton sera “Retour à la liste des ressources”
              </div>
            </div>
          }
        </Grid>
      </Grid>
    </div>
  );
};

export default ModelVariable1;
